/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*****************************
指定されたURLの配列を読み込んだら $.Deferred を返す
***********************************/
/*
var urls = ['image1.jpg', 'image2.jpg', 'image3.jpg'];
var preload = require('./caracol2/util/preload.js');

preload( urls,{
    onProgress: function( url, total, count, percent ){
        console.log("{progress}", url, total, count, percent);
    }
})
.fail( function( url, jqXHR, textStatus, errorThrown ){
    console.log("{error}", url);
}).done( function( total, count ){
    console.log("{comp}", total, count);
});
*/

module.exports = function( list, config ){
	'use strict';

	var defaults = {
		// onProgress: function( url, total, count, percent ){}
		onProgress: null
	}
	var opt = jQuery.extend( defaults, config );

	// Deferred オブジェクト
    var defer = $.Deferred();
	var count = 0;
	var total = list.length;

	// 個々のURLを取得し、deferredオブジェクトを返す
	var promise = list.map( function( url ){
		return jQuery.get( url )
		.fail( function( jqXHR, textStatus, errorThrown ){
			defer.rejectWith( this, [url, jqXHR, textStatus, errorThrown] );
		})
		.done( function( e ){
			var percent = ( count +1 ) / total;
			if( opt.onProgress ){
				opt.onProgress( url, total, count, percent );
			}
			count ++;
		});
	});

	// 全部読み込み終わったら実行
	jQuery.when.apply( null, promise )
		.done(function () {
		defer.resolve( total, count );
	});

	// promiseオブジェクトを返して fail()、done()、always()を使えるようにする
	return defer.promise();
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


if ($('#page-story').length) episode();


function episode() {

    // 第一期の続き番号にする
    var NUMBER_DIFF = 26;

    var _data = {
        is_complete: false, // 読み込み終わったか
        episode_list: [],   // 各話データ
        now_list: null,     // 現在表示している話数：サイドメニュー用
        now_episode: null,  // 現在表示している話数：エピソード用
        now_gallery: 0  // 表示するギャラリー
    };
    var _vm_submenu = null;
    var _vm_episode = null;

    $.ajax('episode_data.json', { dataType: 'json', cache:false })
    .done(function (data) {
        _data.episode_list = data.episode_list;
        init_episode();
    });

    /**
     * エピソードのVueを設定
     */
    function init_episode() {

        // urlから表示する話数を出す
        // 指定がなければ最新話を表示
        var show_num = get_num_from_url();
        _data.now_list = show_num;
        _data.now_episode = show_num;

        // サイドメニュー
        _vm_submenu = new Vue({
            el: '#app-list',
            data: _data,
            methods: {
                change_now: change_now
            }
        })

        _vm_episode = new Vue({
            el: '#app-episode',
            data: _data,
            computed: {
                episode: function () {
                    return this.episode_list[this.now_episode];
                },
                convert_number: function () {
                    var str = this.episode.number;
                    str = str.replace(/(\d+)/, '<span>$1</span>');
                    return str;
                }
            },
            methods: {

            }
        });

        // 最初の話数を表示
        change_now(show_num, null);
    }

    /**
     * URLから話数を生成
     */
    function get_num_from_url() {
        if (!$('body.sub-episode').length) {
            // 各話ページではない
            return null;
        }else if( location.hash ){
            return parseInt(location.hash.substr(1)) - NUMBER_DIFF;
        }else{
            return _data.episode_list.length -1
        }
    }

    /**
    * 表示話数変更
    */
    function change_now(num, event) {

        // 各話ページでない場合は普通のリンクとして動かす
        if( !$('body.sub-episode').length ){
            if( event ) window.location = event.target.href;
            return;
        }

        // リストの番号だけ先に変更
        _data.now_list = num;
        // ステータスを読み込み中にする
        _data.is_complete = false;

        // 画像をプリロード
        preload_gallery(num)
        .done( function( total, count ){

            // 読み込み終わったので表示
            _data.now_episode = num;
            _data.is_complete = true;

            // タイトルとURL変更
            var base_title = document.title.substr( document.title.indexOf(' |') );
            document.title = _vm_episode.episode.number + base_title;
            location.hash = num + NUMBER_DIFF;
        });
    }

    // 指定話数の画像プリロード
    function preload_gallery(num) {
        var episode = _vm_episode.episode_list[ num ];
        var urls = episode.images.map(function (image) { return image.src });
        var preload = __webpack_require__(0);
        // $.Differed オブジェクトを返す
        return preload( urls );
    }

}



/***/ }),
/* 2 */
/***/ (function(module, exports) {



if ($('#page-onair').length) page_onair();


function page_onair() {


    $.ajax('/news/season2-onair', {
        dataType: 'json',
        cache: false
    })
    .done(function (data) {
        show_onair_list(data);
    });

}

function show_onair_list(data) {

    // 放送局単体
    var compo_onair = {
        template: '#compo-onair',
        props: {
            onairData: Object
        },
        computed: {
            day: function () {
                return this.onairData.day.replace(/(\d+)/g, '<strong>$1</strong>');
            },
            time: function () {
                var str = this.onairData.time.replace(/(\d+)/g, '<strong>$1</strong>');
                return str.replace(/毎週(.+?)曜/, '毎週<strong>$1</strong>曜');
            }
        }
        // function convert_onair( $onair ){
        //     // 数字を大きく
        //     $onair['day'] = preg_replace( '/(\d+)/', '<strong>\1</strong>', $onair['day'] );
        //     $onair['time'] = preg_replace( '/(\d+)/', '<strong>\1</strong>', $onair['time'] );
        //     // 曜日を大きく
        //     $onair['time'] = preg_replace( '/毎週(.+?)曜/', '毎週<strong>\1</strong>曜', $onair['time'] );

        //     return $onair;
        // }

    };

    var onair_vue = new Vue({
        el: '#app-onair',
        data: data.acf,
        components: {
            'onair-item': compo_onair
        }
    })

}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


// キャラクター表示
// chara_data は外部jsより取得

if( $('#page-character').length ){
    setup_character();
}


/*********************
* セットアップ
*/
function setup_character() {

    var data = chara_data;
    data.now_index = 0;
    data.show_status = 'init';
    data.is_image_loaded = false;   // 大きい画像のプリロード完了
    data.now_chara_img = 'img/dummy.png';  // 現在の画像

    var chara_vue = new Vue({
        el: '#app-chara',
        data: data,
        computed: {
            now_chara: function () {
                return this.chara_list[this.now_index];
            }
        },
        methods: {
            // キャラ詳細表示
            show_detail: show_detail,
            // 閉じるボタン
            close_detail: close_detail,
            // 戻る、進むボタン
            prev_detail: $.proxy(prev_detail, chara_vue),
            next_detail: $.proxy(next_detail, chara_vue)
        }
    });

    $(window).on('resize', $.throttle( 100, function(){
        $('.chara-popup__visual img').responsify();
    }));

    /*********************
    * 特定IDの画像を取得
    */
    function get_index_image(index) {
        return chara_vue.img + chara_vue.chara_list[index].id + '.jpg';
    }

    /*********************
    * 特定のIDのキャラを表示
    * @this chara_vue
    */
    function show_detail(index) {
        var self = chara_vue;
        var next_index = index;

        // 画像読み込み前の状態
        self.is_image_loaded = false;
        // 番号を入れ替え
        self.now_index = next_index;

        // ポップアップを開く
        self.show_status = 'open';
        $('body').addClass('is-popup');

        // ビジュアルを読み込んだらフェードイン＆自動リサイズ
        var preload = __webpack_require__(0);
        preload( [ get_index_image(next_index) ] )
        .done(function (total, count) {
            setTimeout(function () {
                self.now_chara_img = get_index_image(next_index);
                $('.chara-popup__visual img').responsify();
                self.is_image_loaded = true;
            }, 500);
        });
    }

    /*********************
    * 戻るボタン
    * @this chara_vue
    */
    function prev_detail() {
        var index = this.now_index -1  >= 0 ? this.now_index -1 : this.chara_list.length -1;
        show_detail( index );
        return false;
    }

    /*********************
    * 進むボタン
    * @this chara_vue
    */
    function next_detail(){
        var index = (this.now_index +1) % this.chara_list.length;
        show_detail( index );
        return false;
    }

    /*********************
    *閉じる
    * @this chara_vue
    */
    function close_detail() {
        this.is_image_loaded = false;
        this.show_status = "close";
        $('body').removeClass('is-popup');
    }
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {


// ステージ作成
var stage = new createjs.Stage("js-particle");

// パーティクルシステム
var particleSys = new particlejs.ParticleSystem();

// 初期のパーティクル発生量
var emitFrequency = null;

// パーティクルの描画をステージに登録
stage.addChild( particleSys.container );

// パーティクルパラメーター読み出し
$.ajax( 'js/parameter.json?2', {
	dataType: 'json'
})
.done( function( data ){
	// 初期発生量を記録
	emitFrequency = data.emitFrequency;
	// jsonパラメータ
	particleSys.importFromJson( data );
	// フレームレート
	createjs.Ticker.framerate = 30;
	// requestAnimationFrameで定期描画
	createjs.Ticker.timingMode = createjs.Ticker.RAF;
	// 定期的に呼ばれる関数
	createjs.Ticker.addEventListener("tick", handleTick );
	// サイズ調整
	handleResize();
	$(window).on('resize', $.throttle( 200, handleResize ));
});

/*******************
* ウィンドウリサイズ
*/
function handleResize(){
	var w =  window.innerWidth;
	var h = window.innerHeight;
	// var ratio = window.devicePixelRatio;
	var ratio = 1;

	// ステージサイズ調整
	stage.canvas.width = w * ratio;
	stage.canvas.height = h * ratio;
	// パーティクル発生位置の調整
	particleSys.startXVariance = w * 1.5 * ratio;
	particleSys.startY = h * 1.2 * ratio;
	// モバイルではパーティクル発生量を抑える
	if( $.isMobile ){
		particleSys.emitFrequency = emitFrequency * .5;
	}else{
		particleSys.emitFrequency = emitFrequency;
	}
}

/*******************
* requestAnimationFrame で呼ばれる関数
*/
function handleTick(){
	// パーティクルの発生・更新
	particleSys.update();
	// 描画更新
	stage.update();
}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*****************************************

jQuery.CaracolWordpressJsonp
version 4.0
Hiroshi Fukuda <dada@sygnas.jp>
http://sygnas.jp/

WordPress用 Jsonp吐き出しプラグイン「Export File Jsonp」の吐き出すJsonpを読み込んで表示する
*/

/*
{%ID%}		記事ID
{%NUM%}		記事番号 0～
{%TYPE%}	post / カスタムタイプ
{%POSTDAY%}	投稿日
{%POSTDAY_Y%}	投稿日　年
{%POSTDAY_M%}	投稿日 月
{%POSTDAY_D%}	投稿日 日
{%POSTTIME%}	投稿日 年
{%POSTTIME_H%}	投稿時刻　時
{%POSTTIME_M%}	投稿時刻　分
{%POSTTIME_S%}	投稿時刻　秒
{%TITLE%}	題名
{%LINK%}	記事URL
{%THUMB_SRC%}	サムネイル　URL
{%THUMB_WIDTH%}	サムネイル　幅
{%THUMB_HEIGHT%}	サムネイル　高さ
{%CATEGORY_NAME%}	記事カテゴリ
{%CATEGORY_SLUG%}	記事カテゴリスラッグ
{%CATEGORY_NAME_ALL%}	記事カテゴリ　全部
{%CATEGORY_SLUG_ALL%}	記事カテゴリスラッグ　全部
{%TERM_SLUG%}	タクソノミースラッグ
{%TERM_SLUG_ALL%}	タクソノミースラッグ　全部
{%CONTENT%}	本文
{%CUSTOM_任意文字%}	カスタムフィールド

2016.11.22 ver4.1
・$.ajax.done(); 方式に変更

2016.05.09 ver4.0
・Webpack用に刷新

2015.12.17 ver3.0
・画像処理とか外して作り直し。フォーマット置換文字列も変更

2013.11.04 ver2.0
・修正点不明

2013.09.17 ver1.9
・Wordpress標準のアイキャッチ画像を使うように変更

2013.09.17 ver1.8
・{%DAY_Y%}、{%DAY_M%}、{%DAY_D%}　を追加

2013.06.30 ver1.7
・{%CATEGORY%}と{%TERM%}を統合した{%TOTALCATEGORY%}を追加

2013.05.18 ver1.6
・画像読み込み方法を修正

-------------
usage
-------------
var CaracolWordpressJsonp = require('./caracol/wordpress/jquery.wpjsonp.js');
wpjsonp = new CaracolWordpressJsonp({
    format: '<dt>{%POSTDAY%}</dt><dd><a href="{%LINK%}">{%TITLE%}</a></dd>',
    onComplete: function( data ){
        $('.js-news').html(data);
    }
});
wpjsonp.load('http://shingeki.tv/news/output/export_new_jsonp.php');


*/

var CaracolWordpressJsonp;

module.exports = CaracolWordpressJsonp = function( config ){
	'use strict';
	var defaults = {
		format: '<li><a href="{%LINK%}">{%TITLE%}</a></li>',
		onComplete: function(){}
	};

	this.outputArray = [];
	this.opt = jQuery.extend( defaults, config );
};


/***************************************
* 読み込み開始
*/
CaracolWordpressJsonp.prototype.load = function ( jsonpSrc ){
	'use strict';

	var self = this;

	// 読み込み開始
	$.ajax({
		url : jsonpSrc,
		type : 'GET',
		dataType : 'jsonp',
		context: this
	}).done( self.load_complete );
}

/***************************************
* 読み込み完了
*/
CaracolWordpressJsonp.prototype.load_complete = function ( data, textStatus, jqXHR ){
	"use strict";

	for( var i=0; i<data.length; i++ ){

		// 各アーティクル情報
		var article = data[i];
		var format = this.opt.format;

		format = format.split('{%ID%}').join( article.id );
		format = format.split('{%NUM%}').join( i );
		format = format.split('{%TYPE%}').join( article.type );

		format = format.split('{%POSTDAY%}').join( article.postday );
		format = format.split('{%POSTDAY_Y%}').join( article.postday.substr(0,4) );
		format = format.split('{%POSTDAY_M%}').join( article.postday.match(/\d+\.(\d+)\.\d+/)[1] );
		format = format.split('{%POSTDAY_D%}').join( article.postday.match(/\d+\.\d+\.(\d+)/)[1] );

		format = format.split('{%POSTTIME%}').join( article.posttime );
		format = format.split('{%POSTTIME_H%}').join( article.posttime.match(/(\d+):\d+:\d+/)[1] );
		format = format.split('{%POSTTIME_M%}').join( article.posttime.match(/\d+:(\d+):\d+/)[1] );
		format = format.split('{%POSTTIME_S%}').join( article.posttime.match(/\d+:\d+:(\d+)/)[1] );

		format = format.split('{%TITLE%}').join( article.title );
		format = format.split('{%LINK%}').join( article.link );

		if( article.thumbnail ){
			format = format.split('{%THUMB_SRC%}').join( article.thumbnail.src );
			format = format.split('{%THUMB_WIDTH%}').join( article.thumbnail.width );
			format = format.split('{%THUMB_HEIGHT%}').join( article.thumbnail.height );
		}

		format = format.split('{%CATEGORY_NAME%}').join( article.category_name[0] );
		format = format.split('{%CATEGORY_SLUG%}').join( article.category_slug[0] );
		format = format.split('{%CATEGORY_NAME_ALL%}').join( article.category_name.join(' ') );
		format = format.split('{%CATEGORY_SLUG_ALL%}').join( article.category_slug.join(' ') );

		format = format.split('{%TERM_SLUG%}').join( article.terms_slug[0] );
		format = format.split('{%TERM_SLUG_ALL%}').join( article.terms_slug.join(' ') );

		format = format.split('{%CONTENT%}').join( article.content );

		var matches = format.match(/{%CUSTOM_.+?%}/);
		if( matches ){
			for( var p=0; p<matches.length; p++ ){
				var key = matches[p].match(/{%CUSTOM_(.+?)%}/)[1];
				format = format.split( matches[p] ).join( article.custom[key] );
			}
		}

		// 出力テキスト
		this.outputArray.push( format );

	}

	// 指定された完了関数を実行
	this.opt.onComplete( this.outputArray );
};






/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


// WordPressの更新読み込む
var wpJsonpFormat = '<li>' +
	'<a href="{%LINK%}">{%TITLE%}'+
	'<span class="home-news__day">{%POSTDAY%}</span></a></li>';

var CaracolWordpressJsonp = __webpack_require__(5);
var wp_json = new CaracolWordpressJsonp({ format:wpJsonpFormat, onComplete:onWpJsonpLoad });
wp_json.load('//shingeki.tv/news/output/export_new_jsonp.php');


/***************************************************
* WordPressの更新履歴を読んだら実行
*/
function onWpJsonpLoad( outputArray ){
    // outputArray = outputArray.slice(0, 8);
    $('.js-news-content').append( outputArray.join('') );
	// ニュース部分のスクロール
	$('.js-news-scroll').perfectScrollbar();
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// ------------------------------------------------------------
// スタイルの transform を設定する関数
// http://hakuhin.jp/js/css_transform.html
// ------------------------------------------------------------
/*
var transform = require('./caracol/effect/set_transform.js');
var style = $('.target').get(0).style;
transform.set_transform( style, 'scale(.8)' );
*/


exports.set_transform = function (style, value) {

	"use strict";

	var list = [
		"transform",
		"webkitTransform",
		"MozTransform",
		"msTransform",
		"OTransform"
	];
	var i;
	var num = list.length;
	for(i=0;i < num;i++){
		if(style[list[i]] !== undefined){
			style[list[i]] = value;
			return true;
		}
	}
	return false;
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {



var $window = $(window);

// キービジュアルと箱
var $visual = $('.js-visual');
var $box = $('.js-visual-box');

var window_h = null; // ウィンドウサイズ
var visual_h = null; // キービジュアルの高さ
var box_h = null; // キービジュアルを格納する枠の高さ
var box_w = null;
var footer_h = null;

var transform = __webpack_require__(7);

page_home();

function page_home(){
	'use strict';
	// #page-home 以外は抜ける
	if( !$('#page-home').length ) return;

	if( !$.isMobile ){
	    setTimeout( function(){
			// ビジュアルのリサイズ
			$window.on( 'resize', $.throttle( 100, resize_visual ));
			resize_visual();
			// スクロールでビジュアルを動かす
			$window.on( 'scroll', scroll_visual );
			scroll_visual();
	    }, 200);
	}

	// Twitterウィジェット幅調整
	if( $('body').hasClass('isMobile') ){
	    setTimeout( function(){
	        $('.home-twitter iframe').width(
	            $('.home-twitter .home-widget__body').width()
	        );
	    }, 500)
	}

	// wordprss記事一覧
	__webpack_require__(6);

	// パーティクル
	__webpack_require__(4);

	// フェードイン後の処理を登録する
	$(window).on('onFadeinComplete', after_fadein);
}

/**
 * フェードイン後の処理
 */
function after_fadein() {
	// PV再生
	var $movie = $('.js-youtube');
	if ($movie.data('open-movie') == true && Cookies.get('is_movie_showed') != 'true') {
		$movie.trigger('click');
		Cookies.set('is_movie_showed', 'true', { epires: 1 });
	}
}


/*************************
* ビジュアルのスクロール
*/
function scroll_visual(){
	// 必要なスクロール量
	var box_scroll_max = box_h - window_h;
	var visual_scroll_max = visual_h - window_h;

	// キービジュアルとのスクロール比率
	var scroll_par = visual_scroll_max / box_scroll_max;
	// 現在のスクロール量
	var now_scroll = $window.scrollTop();
	// ビジュアルのスクロールする量
	var visual_scroll = now_scroll * scroll_par;
	visual_scroll = Math.min( visual_scroll, visual_scroll_max );

// console.log(window_h,  box_h,  visual_h,  box_scroll_max,  visual_scroll_max);

	var style = $visual.get(0).style;
	transform.set_transform( style, 'translateY(-'+visual_scroll+'px)' );
}

/*************************
* ビジュアルのリサイズ
*/
function resize_visual(){
	var VISUAL_W = 1059;
	var VISUAL_H = 1411;
	// // var VISUAL_H_MAX = 1287

	// // 一度高さを 0 にしてから枠のサイズを計測
	// $visual.hide();
	box_w = $box.width();
	// box_h = $box.height();

	// // 縦横どっちの比率を使うか
	// var par = Math.max( box_w / VISUAL_W, box_h / VISUAL_H );
	var par = box_w * 1.05 / VISUAL_W;

	$visual.css({width:VISUAL_W*par, height:VISUAL_H*par});
	// $visual.show();


	// // リサイズ後を取得
	visual_h = $visual.height();
	box_h = $box.height();
	window_h = $window.height();
	footer_h = $('.l-footer').height();
}





/***/ }),
/* 9 */
/***/ (function(module, exports) {

/*****************************************

HTML5 Audio Player

指定したエレメントに記載されたmp3を読んで再生・一時停止するだけ
MPEG-DASHを使う場合は dash.js が必要。

## Usage

```:html
準備
<button class="js-audio-play" data-audio-src="hoge.mp3">再生</button>
再生中
<button class="js-audio-play" data-audio-src="hoge.mp3" data-audio-isplaying="true">再生</button>
```

```:javascript
var CaracolAudioPlayer = require('./caracol2/media/audio_player.js');
var audio_player = new CaracolAudioPlayer('.js-audio-play');
```

2017.03.10 ver 1.0
    ・とりあえず作った

*****************************************/

var CaracolAudoiPlayer;

module.exports = CaracolAudoiPlayer = function( target ){
    'use strict';

    this.is_autoplay = false;    // 自動再生するか
    this.is_playing = false;    // 再生中か

    this.$now_element = null;   // 現在再生中のボタン
    this.audio = null;          // <audio>エレメント

    this.is_can_play_hds = null;   // HDSを再生できるか
    this.is_can_play_hls = null;   // HLSを再生できるか
    this.is_support_mse = null;    // MedisSourceExtensionに対応しているか
    this.is_streaming = null;       // 押されたボタンのソースはストリーミング指定されているか
    this.dash_player = null;        // MPEG-DASH のプレイヤー（dash.js）

    var self = this;
    _init();

    /***********************
     * 初期化
     */
    function _init() {
        // HTML5 Audioエレメント生成
        self.audio = new Audio();

        // 再生終了イベント
        self.audio.addEventListener('ended', stop_sound);

        // 再生ボタンクリック
        $(target).on('click', _sound_btn_click);
    }

    /**************
     * 再生ボタンクリック
     * @this btn element
     */
    function _sound_btn_click() {
        // ストリーミングか
        self.is_streaming = $(this).data('audio-streaming') == true ? true : false;

        try {
            if (self.is_can_play_hds === null && self.is_streaming) {
                // ストリーミング設定なら環境チェック（初回のみ）
                self.is_can_play_hls = _is_can_play_hls();
                self.is_can_play_hds = _is_can_play_hds();
                self.is_support_mse = _is_support_mse();
            }
        } catch (e) {
            alert(e);
        }

        if (self.is_streaming && !self.is_can_play_hds && !self.is_can_play_hls && !self.is_support_mse) {
            // ストリーミングで、どの方式も対応していなければ抜ける
            return false;
        }

        if( self.$now_element && this === self.$now_element.get(0)){
            // 再生中＆現在アクティブなボタンと同一なら一時停止
            _pause_sound();
        }else{
            // 新規再生
            _play_new_sound(this);
        }
        return false;
    }

    /**************
    * 一時停止
    */
    function _pause_sound(){
        if( self.is_playing ){
            self.audio.pause();
            _change_is_playing(false);
        }else{
            self.audio.play();
            _change_is_playing(true);
        }
    }

    /**************
    * 再生終了
    */
    function stop_sound(){
        _change_is_playing(false);
        self.$now_element = null;
    }

    /**************
    * 新規再生
    */
    function _play_new_sound (elm){
        // 再生中のものがあれば停止
        if(self.$now_element){
            self.audio.pause();
            _change_is_playing(false);
        }

        self.$now_element = $(elm);

        var base = self.$now_element.data('audio-src');
        // メディアごとの再生設定
        _set_src_to_player(base);

        self.audio.load();
        self.audio.play();
        _change_is_playing(true);
    }

    /**************
    * オーディオソースを取得
    */
    function _set_src_to_player(base) {

        if (!self.is_streaming) {
            self.audio.src = base;

        } else if (self.is_can_play_hls) {
            self.audio.src = "http://" + base + "/playlist.m3u8";

        } else if (self.is_can_play_hds) {
            self.audio.src = "http://" + base + "/manifest.f4m";

        } else if (self.is_support_mse) {
            _use_dash_player(base);
        }
    }

    /**************
    * dasj.js をプレイヤーにする
    */
    function _use_dash_player(base) {
        var url = "http://" + base + "/manifest.mpd";

        if (self.dash_player === null) {
            // プレイヤー初期化
            self.dash_player = dashjs.MediaPlayer().create();
            self.dash_player.initialize(self.audio, url, self.is_autoplay);
        } else {
            self.dash_player.attachSource(url);
        }
        return
    }

    /**************
    * HLSを再生できるか
    */
    function _is_can_play_hls() {
        return self.audio.canPlayType("application/vnd.apple.mpegURL") == "maybe" ? true : false;
    }

    /**************
    * HDSを再生できるか
    */
    function _is_can_play_hds() {
        return self.audio.canPlayType("application/f4m+xml") == "maybe" ? true : false;
    }

    /**************
    * MediaSourceExtensionに対応しているか
    */
    function _is_support_mse() {
        var hasWebKit = (window.WebKitMediaSource !== null && window.WebKitMediaSource !== void 0);
        var hasMediaSource = (window.MediaSource !== null && window.MediaSource !== void 0);
        return (hasWebKit || hasMediaSource);
    }

    /**************
    * 再生状態変更
    */
    function _change_is_playing( bool ){
        self.$now_element.attr('data-audio-isplaying', bool);
        self.is_playing = bool;
    }

    function log(msg) {
        var i;
        for (i = 0; i < arguments.length; i++) {
            console.log(arguments[i]);
        }
    }

};



/***/ }),
/* 10 */
/***/ (function(module, exports) {


// スマホでのサードメニュー位置調整
if( $.isMobile && $('.js-move-thirdmenu').length ){
    var active_third = $('.js-move-thirdmenu > li[data-menu-active="true"] .c-thirdmenu');
    if( active_third.length ){
        // サードメニューを移動させる
        $('.js-move-thirdmenu').after( active_third );
    }
}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// var $window = $(window);

// メニューon/off
$('.js-header-pop-open').click(function(){
    var $target = $('.js-header-pop-target');
    var status = $target.attr('data-sp-menu');
    var $body = $('body');

    $target.attr('data-sp-menu', status!=='open' ? 'open' : 'close');
    $(this).attr('data-sp-menu', status!=='open' ? 'open' : 'close');
    $('body').toggleClass('is-popup');

    // 現在のスクロール座標を記録・復元
    if( $target.attr('data-sp-menu') === 'open' ){
    	var scroll = $('body').scrollTop();
    	$body.attr('data-scroll', scroll)
        // $body
	    .attr('data-sp-menu', 'open')
    	.css({top: -scroll});


    }else{
	    $body.attr('data-sp-menu', 'close')
    	.scrollTop( $body.attr('data-scroll') )
    	.css({top: 0});
    }

    return false;
});


// スマホのサイドメニューオープン
$('.js-sidemenu-open-btn').on('click',function(){
    var $parent = $(this).parent();
    if( $parent.attr('data-menu-open') == 'true' ){
        $parent.attr('data-menu-open', 'false');
    }else{
        $parent.attr('data-menu-open', 'true');
    }
    return false;
});


// $('.js-menu-open-target a').click(function(event) {
//     var $target = $('.js-menu-open-target');
//     $target.removeClass('header__content_open');
//     $target.addClass('header__content_close');
// });

// トップページのメニュー位置調整
// if( $('#page-home').length && !$('body').hasClass('isMobile') ){
//     var $header = $('.visual .header');
//     var $visual = $('.visual');

//     function set_mainmenu_position(){
//         var visual_bottom = $visual.offset().top +  $visual.height();
//         var win_bottom = $window.scrollTop() + $window.height();

//         if( visual_bottom > win_bottom ){
//             $header.css({position:'fixed'});
//         }else{
//             $header.css({position:'absolute'});
//         }
//     }
//     $.throttle( 100, set_mainmenu_position );
//     set_mainmenu_position();
// }



/***/ }),
/* 12 */
/***/ (function(module, exports) {


// 画像ポップアップ
 $('a.js-magnific').magnificPopup({
    type: 'image'
 });

// youtube用ポップアップ
$('a.js-youtube').magnificPopup({
    disableOn: 700,
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    type: 'iframe',
    iframe: {
        patterns: {
            youtube: {
                index: 'youtube.com',
                id: 'v=',
                src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
            }
        }
    }
});



/***/ }),
/* 13 */
/***/ (function(module, exports) {

/*
各種ソーシャルサービスボタンを簡単設置

2016/11/24 ver.2.0.0
	- Webpack対応
*/


exports.set_share_button = function( target ){
	'use strict';

	var window_opt = "width=550, height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1";
	var e = encodeURIComponent;

	// クリック動作
	$(document).on('click', target, function(){
		var $this = $(this);
		var url = $this.data('ccl-share-url');
		var msg = $this.data('ccl-share-msg');
		var via = $this.data('ccl-share-via');
		var flw = $this.data('ccl-share-flw');

		if( !url ) url = location.href;
		if( !msg ) msg = document.title;

		switch( $this.data('ccl-share-svc') ){
			case 'twitter':
				twitter(url, msg, via, flw); break;
			case 'facebook':
				facebook(url); break;
			case 'line':
				line(url, msg); break;
			case 'feedly':
				feedly(url); break;
			case 'pocket':
				pocket(url); break;
			case 'hatebu':
				hatebu(url, msg); break;
			case 'google':
				google(url); break;
		}

		return false;
	});

	/***************************
	* Twitter
	*/
	function twitter( url, msg, via, follow ){
		var openURL = 'http://twitter.com/share?url=' + e(url) + '&text=' + e(msg) + '+';
		if( via ) openURL += '&via=' + e(via);
		if( follow ) openURL += '&related=' + e(follow);
		window.open( openURL, 'tweetwindow', window_opt );
		return false;
	}

	/***************************
	* Facebook
	*/
	function facebook( url ){
		var openURL = 'http://www.facebook.com/share.php?u='+ e(url);
		window.open( openURL, 'facebookwindow', window_opt );
		return false;
	}

	/***************************
	* LINE
	*/
	function line( url, msg ){
		window.location.href = 'line://msg/text/' + e(msg) + ' ' + e(url);
		return false;
	}

	/***************************
	* feedly
	*/
	function feedly( url ){
		var openURL = 'http://feedly.com/i/subscription/feed/' + e(url);
		window.open( openURL, 'feedlywindow', window_opt );
		return false;
	}

	/***************************
	* Pocket
	*/
	function pocket( url ){
		var openURL = 'http://getpocket.com/edit?url=' + e(url);
		window.open( openURL, 'feedlywindow', window_opt );
		return false;
	}

	/***************************
	* はてなブックマーク
	*/
	function hatebu( url, msg ){
		var openURL = '//b.hatena.ne.jp/add?mode=confirm&url=' + e(url) + "&title=" + e(msg);
		window.open( openURL, 'hatebuwindow', window_opt );
		return false;
	}

	/***************************
	* google plus
	*/
	function google( url ){
		var openURL = 'https://plus.google.com/share?url=' + e(url);
		window.open( openURL, 'googlewindow', window_opt );
		return false;
	}

};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

/*****************************************

jQuery.syg_pagescroll
version 1.3
Hiroshi Fukuda <dada@sygnas.jp>
http://sygnas.jp/

The MIT License

Copyright (c) 2011-2012 Hiroshi Fukuda, http://sygnas.jp/

/*****************************************


/*****************************************
= example 1 =

	<a href="#hogehoge">hogehoge</a>

	<div id="hogehoge">
	</div>

	<script src="lib/jquery.syg_pagescroll.1.0.js"></script>
	<script>
		new $.SygPageScroll( 'a' );
	</script>


= example 2 =

	<a href="#hogehoge" class="scroll">hogehoge</a>

	<div id="hogehoge">
	</div>

	<script src="lib/jquery.easing.1.3.js"></script>
	<script src="lib/jquery.syg_pagescroll.1.0.js"></script>
	<script>
		new $.SygPageScroll( 'a.scroll', {time:2000, easing:'easeInOutCubic'} );
	</script>

*****************************************/

/*****************************************

2016.11.23 ver.2.1
	・$(target).click(); を $(document).on('click',target,function(){}); に変更
2016.06.8 ver 2
	・Webpack用に作り直し
2015.04.26 ver 1.3
	・スクロール先IDが無い場合は普通にリンクさせる
2013.03.08 ver 1.1
	・位置補正オプション「plus」を追加。

*****************************************/

var CaracolPageScroll;

module.exports = CaracolPageScroll = function( target, config ){
	'use strict';

	var defaults = {
		easing:			'swing',
		time:			1000,
		plus:			0
	};

	this.opt = $.extend( defaults, config );

	var self = this;
	var opt = this.opt;

	/*****************************
	* click setting
	*/
	$(document).on('click',target,
		$.proxy(
			function( e ){
				var hash = e.currentTarget.hash;

				if( $(hash).get(0) ){
					var y = $(hash).offset().top +opt.plus;
					$('html,body').animate( {scrollTop:y}, self.opt.time, self.opt.easing );
					return false;
				}else{
					return true;
				}

			}
		)
	);

};



/***/ }),
/* 15 */
/***/ (function(module, exports) {

/*****************************
スクロールでエリアに入るとクラスを付与

target : 検知対象となる class / id
config : {
	class:{
		// 画面内に入ったら付与
		'in' : 'inView_in',
		// 画面の外に出たら付与
		'out' : 'inView_out'
	}
	// 画面に入った判定の距離。0にすると画面端で判定
	// 必ずin_rangeより小さい値にする
	in_range : 50,
	// 画面から出た判定の距離
	out_range: 0,
	//表示エリアの中だけピンをたてる。上にスクロールするとまた表示
	is_inView_only: false
}


*/
var CaracolScrollInView;

module.exports = CaracolScrollInView = function( target, config ){
	'use strict';

	var defaults = {
		class:{
			in : 'inView_in',
			out : 'inView_out'
		},
		in_range : 50,
		out_range: 40,  // 画面外判定。
		margin_bottom: 50,  // 最下部の許容値
		is_inView_only: false

	};
	this.opt = $.extend( defaults, config );
	this.target = target;
	this.$target = $(target);
	this.is_started = false;
	this.is_ended = false;  // 全部表示した
	this.$window =$(window);
	this.win_height = null;
	this.doc_height = null;

	this.ev_check_element = null;

	this.DATA_TOP = 'ccl-inView-top';
	this.DATA_BOTTOM = 'ccl-inView-bottom';

};

/********************
* スクロール検知処理を開始
*/
CaracolScrollInView.prototype.start = function(){
	'use strict';
	// すでに開始していたら無視
	if( this.is_started ) return;

	// 各アイテムの高さをチェック
	this.check_element();
	this.ev_check_element = setInterval( $.proxy( this.check_element, this ), 2000 );

	// リサイズイベントでドキュメント高さチェック
	this.resize();
	var ev_resize = $.throttle( 100, $.proxy( this.resize, this ));
	this.$window.on( 'resize', ev_resize );

	// スクロールイベント
	this.scroll();
	var ev_scroll = $.throttle( 100, $.proxy( this.scroll, this));
	this.$window.on( 'scroll', ev_scroll );

	this.is_started = true;
};

/********************
* 検知処理を終了
*/
CaracolScrollInView.prototype.stop = function(){
	'use strict';
	clearInterval( this.ev_check_element )
	this.$window.off( 'resize', this.resize );
	this.$window.off( 'scroll', this.scroll );
}

/********************
* 対象エレメントの座標と高さをチェック
*/
CaracolScrollInView.prototype.check_element = function(){
	'use strict';
	var DATA_TOP = this.DATA_TOP;
	var DATA_BOTTOM = this.DATA_BOTTOM;

	this.$target.each( function(){
		var $elm = $(this);
		var top = $elm.offset().top;
		var bottom = top + $elm.height();
		$elm.data( DATA_TOP, top );
		$elm.data( DATA_BOTTOM, bottom );
	});
}

/********************
* スクロール処理
*/
CaracolScrollInView.prototype.scroll = function(){
	'use strict';

	var self = this;
	var $window = this.$window;
	var $target = this.$target;
	var opt = this.opt;

	// スクロール上位置と下位置
	var scroll_top = $window.scrollTop();
	var scroll_bottom = scroll_top + this.win_height;

	// 対象エレメントを順にチェック
	$target.each( function(){

		// エレメントの上辺・下辺を取得
		var $elm = $(this);
		var top = $elm.data( self.DATA_TOP );
		var bottom = $elm.data( self.DATA_BOTTOM );


		// エリア内限定の設定ではなく、
		// すでに完了クラスが付与されていたら無視
		if( !opt.is_inView_only && $elm.hasClass(opt.class.in) ) return true;

		if( !opt.is_inView_only ){
			// 画面内判定：表示エリアより上は全部ピン立てる
			if( scroll_bottom - opt.in_range > top  ){
				$elm.addClass( opt.class.in );
			}
		}else{
			// 表示エリア内だけ
			if( self.is_inView( top, bottom, scroll_top, scroll_bottom )){
				$elm.removeClass( opt.class.out );
				$elm.addClass( opt.class.in );
			}else if( $elm.hasClass( opt.class.in ) && self.is_outView( top, bottom, scroll_top, scroll_bottom ) ){
				$elm.removeClass( opt.class.out );
				$elm.addClass( opt.class.out );
			}
		}
	});

	// エリア内限定でないなら、一番下までスクロールしたら停止
	if( !opt.is_inView_only ){
		if( scroll_bottom >= this.doc_height - opt.margin_bottom ){
			self.stop();
		}
	}
};

/********************
* エリア内にエレメントが見えているか
* element top / element bttom / scroll top / scroll bottom
*/
CaracolScrollInView.prototype.is_inView = function( et, eb, st, sb ){
	'use strict';
	var ir = this.opt.in_range;
	// 上辺が画面内 || 下辺が画面内
	if( st + ir < et && et < sb - ir || st + ir < eb && eb < sb - ir ) return true;
	return false;
}

/********************
* エリア外に移動したか
* element top / element bttom / scroll top / scroll bottom
*/
CaracolScrollInView.prototype.is_outView = function( et, eb, st, sb ){
	'use strict';
	var or = this.opt.out_range;
	// 下辺が画面外 || 上辺が画面外
	if( eb < st + or || sb - or < et ) return true;
	return false;
}


/********************
* ウィンドウをリサイズしたら高さなどをチェック
*/
CaracolScrollInView.prototype.resize = function(){
	'use strict';
	this.win_height = this.$window.height();
	this.doc_height = $(document).height();
}



/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/*****************************
画像や、ファイルの読み込みによるプログレスバー

2016/12/05 ver 1.2.0	読み込み部分を別ライブラリに分けた
						onError() を用意した
2016/05/27 ver 1.1.1	違うhostnameのものは弾くようにした
2016/05/24 ver 1.1	onProgress() に urlを追加
						add_urls() を追加
2016/05/20 ver 1.0	とりあえず作成
*/

/* [javascript] *********************************
var $progress_bar = $('#fadein .fadein__progress');
var CaracolLoadProgress = require('./caracol/util/jquery.load_progress.js');

var progress = new CaracolLoadProgress({
	onProgress: function( total, count, percent ){
		$progress_bar.css({ width: (percent * 100)+'%' });
	},
	onComplete: function( total, count ){
		$progress_bar.css({ width: '100%' });
		setTimeout( function(){ $('#fadein').remove(); }, 1700);
	}
});
progress.start();
***********************************/

/* [補足] *********************************
progress.add_urls( array );

自動的に <img src="〜"> <image src="〜"> を読み込み対象とするが、
それ以外に読み込みに追加したいファイルを配列で指定。
***********************************/



var CaracolLoadProgress;

module.exports = CaracolLoadProgress = function( config ){
	'use strict';

	var defaults = {
		onProgress: function( total, count, percent ){},
		onComplete: function( total, count ){},
		onError: function( url, jqXHR, textStatus, errorThrown ){},
		urls: []
	}
	this.opt = jQuery.extend( defaults, config );
	this.urls = this.opt.urls;
	this.total = 0;
}
/***************************
* add url
*/
CaracolLoadProgress.prototype.add_urls = function( list ){
	'use strict';
	this.urls = this.urls.concat( list );
}
/***************************
* start
*/
CaracolLoadProgress.prototype.start = function(){
	'use strict';

	var self = this;
	// var count = 0;
	var finished = [];

	// 画像を数える
	this.checkImageTags();

	// 画像他をプリロード
	var preload = __webpack_require__(0);
	preload( this.urls, {
		onProgress: function( url, total, count, percent ){
			self.opt.onProgress( total, count, percent, url );
			finished.push( url );
		}
	})
	.fail( function( url, jqXHR, textStatus, errorThrown ){
		self.opt.onError( url, jqXHR, textStatus, errorThrown );
	})
	.done( function( total, count  ){
		// 全部読み終わった
		self.opt.onComplete( total, count );
	});

	// // 個々のURLを取得し、deferredオブジェクトを返す
	// var promise = this.urls.map( function( url ){
	// 	// console.log(url);
	// 	return jQuery.get( url )
	// 	.then( function( e ){
	// 		var percent = ( count +1 ) / self.total;
	// 		self.opt.onProgress( self.total, count, percent, url );
	// 		finished.push( url );
	// 		count ++;
	// 	});
	// });

	// // 全部読み込み終わったら実行
	// jQuery.when.apply( null, promise )
	// .done( function(){
	// 	self.opt.onComplete( self.total, count );
	// });

	// // 3秒後に読み込めなかったURLを表示
	// setTimeout( function(){
	// 	for( var i=0; i<self.urls.length; i++ ){
	// 		var url = self.urls[i];
	// 		// 終了リストに存在しない
	// 		if( $.inArray( url, finished ) < 0 ){
	// 			console.log("[load error]",url);
	// 		}
	// 	}
	// }, 3000 );

}

/***************************
* check <img> tags
*/
CaracolLoadProgress.prototype.checkImageTags = function(){
	'use strict';

	var hostname = /^https?:\/\/[^\/]+\//.exec( window.location.href )[0];
	var imgs = document.getElementsByTagName('img');
	var images = document.getElementsByTagName('image');
	var length;
	var i;

	// <img>
	length = imgs.length;
	if( length ){
		for( i=0; i<length; i++ ){
			// 違うホストのものは弾く
			if( imgs[i].src.indexOf(hostname) === 0 ){
				this.urls.push( imgs[i].src );
			}
		}
	}

	// SVGの<image>
	length = images.length;
	if( length ){
		for( i=0; i<length; i++ ){
			// 違うホストのものは弾く
			if( images[i].src.indexOf(hostname) === 0 ){
				this.urls.push( images[i].src );
			}
		}
	}

	this.total = this.urls.length;
}



/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {



// プログレス登録
var CaracolLoadProgress = __webpack_require__(16);
var progress = new CaracolLoadProgress({
    // urls: window.app.progress_base_urls,
    onProgress: onProgress, onComplete:onComplete, onError:onError
});
// 読み込んだ外部ファイルで指示されている先読み指定ファイルを取得
progress.add_urls( window.app.progress_page_urls );

// プログレス開始
progress.start();
// start_inView();

/**********************
* エラー
*/
function onError( url, jqXHR, textStatus, errorThrown ){
    console.log("[load error]", url);
}

/**********************
* プログレス：読み込み中
*/
function onProgress( total, count, percent, url ){
    var per = percent * 100;
    $('.js-fadein-progress').css({ width:per+'%' });
}
/**********************
* プログレス：読み込み完了
*/
function onComplete( total, count ){
    setTimeout( function(){
        $('.js-fadein-progress').css({ width:'100%' });
        $('.c-fadein').addClass('c-fadein_start');
    }, 200 );

    // フェードイン終わったら消す
    $('.c-fadein')
    .on("oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend",
        function( e ){
            // 透明度以外のアニメ終了は無視
            if( e.originalEvent.propertyName !== 'opacity' ) return;

            $('.c-fadein').hide();

            // スクロールインエフェクト
            start_inView();

            // フェードイン完了イベント発火
            $(window).trigger('onFadeinComplete');
        }
    );
}
/**********************
* inView 開始
*/
function start_inView(){
    // トップページのビジュアル、アニメスタート
    // $('#page-home .home-bg').attr('data-home-start', 'true');
    // $('#page-home .home__center-sp').attr('data-home-start', 'true');

    var CaracolScrollInView = __webpack_require__(15);
    var inView = new CaracolScrollInView( '.p-iv', {
        class:{
            in:'p-iv_in'
        }
    } );

    // inViewはホームページだけ遅延させる
    // var delay = $('#page-home').length ? 1300 : 0;

    // setTimeout( function(){
    //     // スマホヘッダの表示
    //     $('#page-home .c-sp-header_home').attr('data-home-start', 'true');
        inView.start();
    // }, delay );

    // ちらつき対策のために遅延させる
    if( $('#page-character').length ){
        // setTimeout( function(){
            // require('../page/page_chara.js');
        // }, 1000);
    }
}





/***/ }),
/* 18 */
/***/ (function(module, exports) {

/*****************************
上下スクロールで対象にクラスを付与するクラス
ver 1.0.0

メニューや、トップに戻るボタンの出し入れに使う。

# usage
var scroll_amount = new CaracolScrollAmount( target, {config} );

## target
検知対象となる element

## config
パラメーター。値は初期値。

{
	up: 80,  // 上へのスクロールに反応するスクロール積算値。
	down: 80,  // 下へのスクロールに反応するスクロール積算値。
	offset_top: 50, // スクロール位置がこの値より上ならページ最上部と判断
	offset_bottom: 50, // スクロール位置がこの値より下ならページ最下部と判断

	// 状態によって付与されるクラス
	class:{
		pinned: 'ccl-amount_pinned',
		unpinned: 'ccl-amount_unpinned',
		top: 'ccl-amount_top',
		nottop: 'ccl-amount_not-top',
		bottom: 'ccl-amount_bottom',
		notbottom: 'ccl-amount_not-bottom',
		initial: 'ccl-amount'
	},

	// イベント
	onPin: function(){},
	onUnPin: function(){},
	onTop: function(){},
	onNotTop: function(){},
	onBottom: function(){},
	onNotBottom: function(){}
}

------------------------
ver1.0.0 2016/11/22
- とりあえず作った。

*/
var CaracolScrollAmount;

module.exports = CaracolScrollAmount = function( target, config ){
	'use strict';

	var defaults = {
		up: 80,
		down: 80,
		offset_top: 70,
		offset_bottom: 70,

		// 状態によって付与されるクラス
		class:{
			pinned: 'ccl-amount_pinned',
			unpinned: 'ccl-amount_unpinned',
			top: 'ccl-amount_top',
			nottop: 'ccl-amount_not-top',
			bottom: 'ccl-amount_bottom',
			notbottom: 'ccl-amount_not-bottom',
			initial: 'ccl-amount'
		},
		// イベント
		onPin: function(){},
		onUnPin: function(){},
		onTop: function(){},
		onNotTop: function(){},
		onBottom: function(){},
		onNotBottom: function(){}
	};

	this.opt = $.extend( defaults, config );
	this.target = target;
	this.$target = $(target);
	this.$window =$(window);
	this.win_height = null;	// ブラウザウィンドウの高さ
	// this.doc_height = null;	// ドキュメントの高さ
	this.last_scroll = 0; // 1回前の座標
	this.count_scroll = 0; // スクロール量の積算

	this.is_started = false; // 開始した
	this.is_top = false; // 一番上にスクロールした
	this.is_bottom = false; // 一番下にスクロールした
	this.is_pinned = false; // ピンを立てた

	// 開始
	this.start();
};

/********************
* スクロール検知処理を開始
*/
CaracolScrollAmount.prototype.start = function(){
	'use strict';

	// すでに開始していたら無視
	if( this.is_started ) return;

	// 基礎クラスを付与
	this.$target.addClass( this.opt.class.initial );

	// リサイズイベントでドキュメント高さチェック
	this.resize();
	this.$window.on('resize', $.throttle( 100, $.proxy( this.resize, this )));

	// スクロールイベント
	this.scroll();
	this.is_started = true;
	this.$window.on('scroll', $.throttle( 100, $.proxy( this.scroll, this )));

	// 一応1秒間毎にチェックも入れる
	setInterval( $.proxy( this.scroll, this ), 1000 );
};

/********************
* スクロール検知処理を停止
*/
CaracolScrollAmount.prototype.stop = function(){
	'use strict';
	this.$window.off( 'scroll', $.throttle( $.proxy( this.scroll, this ), 50 ) );
};
/********************
* スクロール処理
*/
CaracolScrollAmount.prototype.scroll = function(){
	'use strict';

	var opt = this.opt;
	var scroll = this.$window.scrollTop();
	var distance = scroll - this.last_scroll; // 移動量

	// 位置イベントのチェック
	this.check_top_bottom( scroll );

	// スクロール量を積算。もし逆方向にスクロールしたらリセット
	if( this.count_scroll > 0 && distance > 0 ){
		this.count_scroll += distance;
	}else if( this.count_scroll < 0 && distance < 0 ){
		this.count_scroll += distance;
	}else{
		this.count_scroll = distance;
	}

	this.last_scroll = scroll;

	// スクロールが規定量越えたらピンを立てる
	if(  this.count_scroll >= opt.down && !this.is_pinned ){
		// 下にスクロール
		this.is_pinned = true;
		this.$target.addClass( opt.class.pinned );
		this.$target.removeClass( opt.class.unpinned );

	}else if( this.count_scroll <= -opt.up && this.is_pinned ){
		// 上にスクロ−ル
		this.is_pinned = false;
		this.$target.addClass( opt.class.unpinned );
		this.$target.removeClass( opt.class.pinned );
	}

};

/********************
* 最上部か最下部かのチェック
*/
CaracolScrollAmount.prototype.check_top_bottom = function( scroll ){
	'use strict';

	var opt = this.opt;
	var $target = this.$target;
	var scroll_bottom = $(document).height() - this.win_height;


	if( !this.is_top && scroll <= opt.offset_top ){
		// ページ最上部
		this.is_top = true;
		$target.addClass( opt.class.top );
		$target.removeClass( opt.class.nottop );
		$target.addClass( opt.class.notbottom );
		opt.onTop();

	}else if( !this.is_bottom && scroll >= scroll_bottom - opt.offset_bottom){
		// ページ最下部
		this.is_bottom = true;
		$target.addClass( opt.class.bottom );
		$target.addClass( opt.class.nottop );
		$target.removeClass( opt.class.notbottom );
		opt.onBottom();

	}else if( this.is_top && scroll > opt.offset_top ){
		// 最上部から離れた
		this.is_top = false;
		$target.addClass( opt.class.nottop );
		$target.removeClass( opt.class.top );
		opt.onNotTop();

	}else if( this.is_bottom && scroll < scroll_bottom - opt.offset_bottom ){
		// 最下部から離れた
		this.is_bottom = false;
		$target.addClass( opt.class.notbottom );
		$target.removeClass( opt.class.bottom );
		opt.onNotBottom();
	}
};


/********************
* ウィンドウをリサイズしたら高さなどをチェック
*/
CaracolScrollAmount.prototype.resize = function(){
	'use strict';
	this.win_height = this.$window.height();
}



/***/ }),
/* 19 */
/***/ (function(module, exports) {

/*****************************
* ブラウザ情報を取得する
*/

exports.isMobile = (function(){ 'use strict'; return isMobile; })();
exports.browser = (function(){ 'use strict'; return browser; })();


var isMobile = checkMobile();
var browser = getBrowser();

/****************************
* モバイル判定
*/
function checkMobile(){
    'use strict';
    var agent = navigator.userAgent;

    if(agent.search(/iPhone/) != -1 || agent.search(/iPad/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1){
        $('body').addClass('isMobile');
        $.isMobile = true;
        return true;
    }else{
        $('body').addClass('isPC');
        $.isMobile = false;
        return false;
    }
}

/****************************
* ブラウザ判別
*/
function getBrowser(){
    'use strict';

    var ua = window.navigator.userAgent.toLowerCase();
    var ver = window.navigator.appVersion.toLowerCase();
    var name = 'unknown';

    if (ua.indexOf("msie") != -1){
        if (ver.indexOf("msie 6.") != -1){
            name = 'ie6';
        }else if (ver.indexOf("msie 7.") != -1){
            name = 'ie7';
        }else if (ver.indexOf("msie 8.") != -1){
            name = 'ie8';
        }else if (ver.indexOf("msie 9.") != -1){
            name = 'ie9';
        }else if (ver.indexOf("msie 10.") != -1){
            name = 'ie10';
        }else{
            name = 'ie';
        }
    }else if(ua.indexOf('trident/7') != -1){
        name = 'ie11';
    }else if (ua.indexOf('chrome') != -1){
        name = 'chrome';
    }else if (ua.indexOf('safari') != -1){
        name = 'safari';
    }else if (ua.indexOf('opera') != -1){
        name = 'opera';
    }else if (ua.indexOf('firefox') != -1){
        name = 'firefox';
    }
    return name;
}




/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {



// ユーザーエージェント確認
__webpack_require__(19);
// cssの transform: をjsで書き換える
// var transform_css = require('./caracol2/effect/transform_css.js');

// var $window = $(window);



/********************************
* DOM読み込み完了
*/
$( function(){
    'use strict';

    // ヘッダと、ページトップに戻るボタンのアクション
    var CaracolScrollAmount = __webpack_require__(18);
    new CaracolScrollAmount( '.js-scroll-amount' );

    // プログレス
    __webpack_require__(17);

    // ページスクロール
    var CaracolPageScroll = __webpack_require__(14);
    new CaracolPageScroll( 'a.js-pagescroll', {time:800, plus:0} );

    // 画像の遅延読み込み
    $('img.js-lazy').lazyload({effect:'fadeIn'});


    // ソーシャルボタン
    __webpack_require__(13).set_share_button( '.js-share-button' );

    // ポップアップ設定
    __webpack_require__(12);

    // メニュー動作
    __webpack_require__( 11 );
    __webpack_require__( 10 );

    var CaracolAudioPlayer =  __webpack_require__(9);
    new CaracolAudioPlayer('.js-audio-play', true);

    // タブ
    // var CaracolTab = require('./caracol2/navigation/tabs.js');
    // new CaracolTab('.js-ccltab_tab');

    // 背景固定
    // require('./module/bgfix.js');

    // スライダー接待
    // require('./module/slider.js');

    // 各ページ用
    __webpack_require__(8);
    // require('./page/page_news.js');
    // require('./page/page_story.js');
    __webpack_require__(3);
    __webpack_require__(2);
    __webpack_require__(1);

    // キャラ用はなかチラつくので module/progress.js で遅延読み込み
    // require('./page/page_chara.js');


});



/***/ })
/******/ ]);